import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aceocean/vesseldeparture'
import pathMap from 'src/paths/pathMap'

class AceOcnVesselDepartureRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_DEPARTURE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_DEPARTURE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_DEPARTURE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACE_OCN_VESSEL_DEPARTURE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceOcnVesselDepartureRoute
